/**
 * Jobs
 * @class
 * @constructor
 * @public
 */
class Jobs {
  /**
   * Constructor
   * @returns {class}
   */
  constructor() {
    this.component = document.querySelector('[data-jobs]');

    // Engage engines
    if (this.component) {
      this.filters = this.component.querySelectorAll('[data-jobs-filter]');
      this.filterArray = {};

      this.init();
    }
  }

  /**
   * Initialize the component
   * @returns {void}
   */
  init() {
    if (this.filters) {
      this.filters.forEach((filter) => {
        filter.addEventListener('change', () => {
          const filterKey = filter.getAttribute('name');
          const filterValue = filter.value;
          delete this.filterArray[filterKey];

          if (filterValue !== '') {
            this.filterArray[filterKey] = filterValue;
            filter.classList.add('is-active');
          } else {
            filter.classList.remove('is-active');
          }

          const url = new URL(window.location.href.split('?')[0]);
          for (const [key, value] of Object.entries(this.filterArray)) {
            url.searchParams.append(key, value);
          }

          window.location.href = url.toString();
        });

      });
    }

  }

}

module.exports = Jobs;
